import { Component, EventEmitter, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { AddonService } from 'src/app/private/services/addon.service';

@Component({
  selector: 'app-addon-list',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './addon-list.component.html',
  styleUrl: './addon-list.component.scss'
})
export class AddonListComponent {
  @Output() editAddon = new EventEmitter<any>();
  @Output() deleteAddon = new EventEmitter<any>();
@Output() openAddon = new EventEmitter<any>();
  addons: any[] = [];
  loading = false;
  totalRecords = 0;
  searchText = '';

  constructor(
    private addonService: AddonService,
    private messageService: MessageService
  ) { }
  openCreateAddon(){
  this.openAddon.emit();
  }
  ngOnInit() {
    this.loadAddons();
  }

  /** --- API CALL --- */
  loadAddons() {
    this.loading = true;

    const data = {
  "page": 0,
  "limit": 1000,
  "where": {
    "is_active": true
  },
  "order": {
    "col": "name",
    "dir": "ASC"
  }
}

    this.addonService.getAllPackageAddon(data).subscribe({
      next: (res: any) => {
        this.addons = res.rows || [];
        this.totalRecords = res.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load add-ons'
        });
        this.loading = false;
      }
    });
  }

  /** --- TEXT CLEAN FIX FOR TYPE --- */
  formatType(type: string): string {
    return type ? type.replace(/_/g, ' ') : '';
  }

  /** --- FORMAT FEATURES TO DISPLAY --- */
  getFeaturesSummary(features: any): string {
    if (!features || typeof features !== 'object') return 'No features';
    
    const featureArray = Object.entries(features).map(([key, value]) => {
      const label = this.formatType(key);
      return `${label}: ${value}`;
    });
    
    return featureArray.join(', ') || 'No features';
  }

  getStatusSeverity(isActive: boolean): 'success' | 'danger' {
    return isActive ? 'success' : 'danger';
  }

  getStatusLabel(isActive: boolean): string {
    return isActive ? 'Active' : 'Inactive';
  }

  /** --- SEARCH FILTER --- */
  filterAddons() {
    const text = this.searchText.toLowerCase();

    return this.addons.filter(addon =>
      !text ||
      addon.name?.toLowerCase().includes(text) ||
      addon.description?.toLowerCase().includes(text)
    );
  }

  onEdit(addon: any) {
    this.editAddon.emit(addon);
  }

  onDelete(addon: any) {
    this.deleteAddon.emit(addon);
  }
}
